import { render, staticRenderFns } from "./RoomAssignment.vue?vue&type=template&id=223300a9&scoped=true&"
import script from "./RoomAssignment.vue?vue&type=script&lang=js&"
export * from "./RoomAssignment.vue?vue&type=script&lang=js&"
import style0 from "./RoomAssignment.vue?vue&type=style&index=0&id=223300a9&prod&lang=scss&"
import style1 from "./RoomAssignment.vue?vue&type=style&index=1&id=223300a9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "223300a9",
  null
  
)

export default component.exports